import React, { useEffect, useState } from 'react'
import { GetCmsPages,getBoardOfDirectorsData } from '../api.services.js/others'
import { Container } from 'react-bootstrap'
import Head from 'next/head'

export const getServerSideProps=async()=>{
  const {data}=await GetCmsPages({identifier:"board-of-director"})
  return{  
           props:{data},
  }

}

function BoardOfDirector(props) {
  const [cmsPage,setcmsPage]= useState(props?.data?.cmsPage?.content);
  const[boardOfDirectorsdata, setBoardofDirectorsData]=useState([])
  const [directorDis, setDirectorDis] = useState({});
  
  useEffect(()=>{
      getBoardOfDirectors()
    },[boardOfDirectorsdata])


    const breadCrumbSchema = () => {
      return {
        __html: `{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Home",
            "item": "https://www.orientbell.com"
          },{
          "@type": "ListItem", 
          "position": 2, 
          "name": "Board Of Directors",
          "item": "https://www.orientbell.com/board-of-director"
        }]
        }`
      }
    } 
const getBoardOfDirectors=async ()=>{
  const response= await getBoardOfDirectorsData();
  setBoardofDirectorsData(response.data.board_of_director)
}

const handleToggle = (index) => {
  setDirectorDis((prevState) => ({
    ...prevState,
    [index]: !prevState[index],
  }));
};



  return(
    <>  
    <Head>
    <title>{props?.data?.cmsPage?.meta_title}</title>
<meta name="title" content={props?.data?.cmsPage?.meta_title}/>
<meta name="description" content={props?.data?.cmsPage?.meta_description}/>
<meta name="keywords" content={props?.data?.cmsPage?.meta_keywords}/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
    </Head>
    <div className='board_directors_page'>
    <Container>
      <div dangerouslySetInnerHTML={{ __html: cmsPage }}></div>
      <div className='board_directors'>
        {boardOfDirectorsdata &&
          boardOfDirectorsdata.length > 0 &&
          boardOfDirectorsdata.map((obj, index) => {
            return (
              <div key={index} className='board_directors_data'>
                <div className='board_director_profile'>
                  <img src={obj.image_src} alt='Director Profile'></img>
                </div>
                <div className='board_director_name'>
                  <div>{obj.name}</div>
                  <p>
                    <span>{obj.designation}</span>
                  </p>
                </div>
                {!directorDis[index] ? (
                  <p>{obj.details_initial}</p>
                ) : (
                  <p>{obj.details_remaining}</p>
                )}
                <button
                  className='btn btn-primary'
                  onClick={() => handleToggle(index)}
                >
                  {!directorDis[index] ? 'Read More' : 'Read Less'}
                </button>
              </div>
            );
          })}
      </div>
    </Container>
          </div>
      </>

 
)
}

export default BoardOfDirector